import { z } from 'zod/v4';

import { normalizeFormWidgetArgs } from './form-widget-args.normalization';
import { partialFormWidgetDataSchema } from './partial-form-widget-data.schema';

/**
 * `data` is the same shared partial `create_form_widget` uses, minus create's two required-string
 * tightenings — an existing form already has a button label and a post-submit outcome, and demanding
 * them again on every restyle would force the model to resupply strings it has no reason to change
 * (and would invite it to invent them). Kept deliberately identical otherwise, so a model that has
 * just seen its own create call can pattern-match straight onto this tool.
 */
const updateFormWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the form widget to update.'),
    data: partialFormWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed. Note fields REPLACES the whole field ' +
            'list, so include every field you want to keep.'
    ),
});

export const updateFormWidgetArgsSchema = z.preprocess(normalizeFormWidgetArgs, updateFormWidgetObjectSchema);
